import { useMutation, useQueryClient } from 'react-query';

import Api from '../../api/api';

export const addAdditionalParentCategory = async (postId: string, parentCategoryId: string) => {
  const [response, bodyOrError] = await Api.post(`posts/${postId}/add-parent`, {
    parentCategoryId,
  });
  if (!response.ok) {
    throw bodyOrError;
  }
  return bodyOrError;
};

export const useAddAdditionalParentCategory = () => {
  const queryClient = useQueryClient();
  return useMutation(
    'addAdditionalParentCategory',
    (data: { postId: string; parentCategoryId: string }) => {
      return addAdditionalParentCategory(data.postId, data.parentCategoryId);
    },
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries(['getPostById', variables.postId]);
      },
    },
  );
};
